import { render, staticRenderFns } from "./HerstellerumsaetzeChartbox.vue?vue&type=template&id=27e4a05c&"
import script from "./HerstellerumsaetzeChartbox.vue?vue&type=script&lang=js&"
export * from "./HerstellerumsaetzeChartbox.vue?vue&type=script&lang=js&"
import style0 from "./HerstellerumsaetzeChartbox.vue?vue&type=style&index=0&id=27e4a05c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports